import React from 'react';
import { Link } from 'react-router-dom';

function Error501() {
  return (
    <div className="page error-bg" id="particles-js">
      <div className="main-error-wrapper page-h d-flex flex-column align-items-center justify-content-center text-center">
        <h1 className="display-1 fw-bold text-danger mb-0">501</h1>
        <h2 className="title mt-2">Not Implemented</h2>
        <h6 className="sub_title text-muted mb-4">The server does not support the functionality required to fulfill the request.</h6>
        <Link className="btn btn-outline-primary px-4 py-2" to="/">
          <i className="fe fe-arrow-left me-2"></i>Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default Error501;